var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{},[_c('h1',[_vm._v("ToDoList "),_c('a',{staticClass:"t-btn",on:{"click":_vm.showTools}},[_c('span')])])])}
var staticRenderFns = []

export { render, staticRenderFns }